// Vendor imports
const _ = require('lodash')
const React = require('react')
const PropTypes = require('prop-types')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')
const morePropTypes = require('client-v2/common/utils/prop-types')
const InputText = require('client-v2/common/components/input-text')

class InputTextAutoSize extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      sizerElem: null,
      sizerWidth: 0
    }
    this.inputRef = this.inputRef.bind(this)
    this.onResize = _.throttle(this.onResize.bind(this), 100)
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (prevState.sizerElem) {
      const sizerWidth = measureSizer(prevState.sizerElem, nextProps)
      return { sizerWidth }
    }
    return null
  }

  onResize() {
    const { getDerivedStateFromProps } = this.constructor
    const nextState = getDerivedStateFromProps(this.props, this.state)
    if (nextState) {
      this.setState(nextState)
    }
  }

  componentDidMount() {
    // There's no DOM during server-side-rendering
    if (typeof window !== 'undefined') {
      const sizerElem = createSizerElem()
      const sizerWidth = measureSizer(sizerElem, this.props)
      this.setState({ sizerElem, sizerWidth })
      window.addEventListener('resize', this.onResize)
    }
  }

  componentWillUnmount() {
    if (this.state.sizerElem) {
      removeSizerElem(this.state.sizerElem)
      window.removeEventListener('resize', this.onResize)
    }
  }

  inputRef(el) {
    this.input = el
    // Expose ref to parent component
    // https://reactjs.org/docs/refs-and-the-dom.html#exposing-dom-refs-to-parent-components
    const { inputRef } = this.props
    if (_.isFunction(inputRef)) {
      inputRef(el)
    } else if (_.isObject(inputRef)) {
      inputRef.current = el
    }
  }

  blur() {
    this.input.blur()
  }

  focus() {
    this.input.focus()
  }

  render() {
    const size = sizerString(this.props).length
    let style
    if (this.state.sizerElem) {
      const width = this.state.sizerWidth + 'px'
      style = { width }
    }
    return tag(InputText, {
      ...this.props,
      size,
      style,
      inputRef: this.inputRef
    })
  }
}

// Sizer element utilities

const SIZER_STYLE = [
  'position: absolute',
  'visibility: hidden',
  'white-space: pre'
].join('; ')

function createSizerElem() {
  const sizerElem = document.createElement('span')
  sizerElem.setAttribute('style', SIZER_STYLE)
  document.body.appendChild(sizerElem)
  return sizerElem
}

function removeSizerElem(sizerElem) {
  document.body.removeChild(sizerElem)
}

function measureSizer(sizerElem, props) {
  sizerElem.className = props.className
  sizerElem.innerHTML = sizerString(props)
  .replace(/&/g, '&amp;')
  .replace(/</g, '&lt;')
  .replace(/>/g, '&gt;')
  return sizerElem.getBoundingClientRect().width
}

function sizerString(props) {
  return String(props.value || props.placeholder)
}

InputTextAutoSize.propTypes = {
  className: PropTypes.string,
  inputRef: morePropTypes.domRef,
  placeholder: PropTypes.string,
  value: PropTypes.string
}

module.exports = InputTextAutoSize
